import React, { useRef, useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Keyboard, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import "./NavigasiDivisi.scss";

// IMPORT COMPONENT
import TopInfo from '../../Components/TopInfo/TopInfo';
import Heading from '../../Components/Heading/Heading';
import { Link } from 'react-router-dom';

import kampana from "../../Assets/NavigasiDivisi/Kampana Large.jpeg";
import adhyasta from "../../Assets/NavigasiDivisi/Adhyasta Large.jpeg";
import arsa from "../../Assets/NavigasiDivisi/Arsa Large.jpeg";
import bimantara from "../../Assets/NavigasiDivisi/Bimantara Large.jpeg";
import dayaka from "../../Assets/NavigasiDivisi/Dayaka Large.jpeg";
import prabangkara from "../../Assets/NavigasiDivisi/Prabangkara Large.jpeg";
import sambara from "../../Assets/NavigasiDivisi/Sambara Large.jpeg";
import sarwaga from "../../Assets/NavigasiDivisi/Sarwaga Large.jpeg";
import syandana from "../../Assets/NavigasiDivisi/Syandana Large.jpeg";
import wiskira from "../../Assets/NavigasiDivisi/Wiskira Large.jpeg";

import arsaLogo from "../../Assets/FotoDivisi/arsa/Logo.webp";
import kampanaLogo from "../../Assets/FotoDivisi/kampana/Logo.webp";
import adhyastaLogo from "../../Assets/FotoDivisi/adhyasta/Logo.webp";
import bimantaraLogo from "../../Assets/FotoDivisi/bimantara/Logo.webp";
import dayakaLogo from "../../Assets/FotoDivisi/dayaka/Logo.webp";
import prabangkaraLogo from "../../Assets/FotoDivisi/prabangkara/Logo.webp";
import sambaraLogo from "../../Assets/FotoDivisi/sambara/Logo.webp";
import sarwagaLogo from "../../Assets/FotoDivisi/sarwaga/Logo.webp";
import syandanaLogo from "../../Assets/FotoDivisi/syandana/Logo.webp";
import wiskiraLogo from "../../Assets/FotoDivisi/wiskira/Logo.webp";

const NavigasiDivisi = () => {
    return (
        <>
            <div className="NavigasiDivisi">
                <div className="Background"></div>
                <TopInfo />
                <Heading nama="Foto Divisi" job="" />
                <div className="box-swiper">
                    <Swiper
                        slidesPerView={2}
                        centeredSlides={false}
                        slidesPerGroupSkip={0}
                        loop={true}
                        grabCursor={true}
                        keyboard={{
                            enabled: true,
                        }}
                        breakpoints={{
                            769: {
                                slidesPerView: 2,
                                slidesPerGroup: 2,
                            },
                        }}
                        navigation={true}
                        pagination={{
                            el: '.swiper-pagination',
                            clickable: true,
                        }}
                        spaceBetween={16}
                        modules={[Keyboard, Navigation, Pagination]}
                        className="mySwiper"
                    >
                        <SwiperSlide>
                            <Link to="/divisi-bimantara" className="box-link">
                                {/* <a className="box-link" href="/divisi-bimantara"> */}
                                <img className="foto" src={bimantara} alt="" />
                                <div className="shadow-top"></div>
                                <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(16,82,184,0), rgba(16,82,184,1)" }}></div>
                                <div className="info-divisi">
                                    <div className="box">
                                        <div className="box-text">
                                            <p className="divisi">Divisi</p>
                                            <p className="nama">BIMANTARA</p>
                                        </div>
                                        <div className="box-logo">
                                            <img className="logo" src={bimantaraLogo} alt="" />
                                        </div>
                                    </div>
                                    <p className="job">Badan Pengurus Harian (BPH)</p>
                                </div>
                                {/* </a> */}
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/divisi-kampana" className="box-link">
                                {/* <a className="box-link" href="/divisi-kampana"> */}
                                <img className="foto" src={kampana} alt="" />
                                <div className="shadow-top"></div>
                                <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(184,17,13,0), rgba(184,17,13,1)" }}></div>
                                <div className="info-divisi">
                                    <div className="box">
                                        <div className="box-text">
                                            <p className="divisi">Divisi</p>
                                            <p className="nama">KAMPANA</p>
                                        </div>
                                        <div className="box-logo">
                                            <img className="logo" src={kampanaLogo} alt="" />
                                        </div>
                                    </div>
                                    <p className="job">Acara</p>
                                </div>
                                {/* </a> */}
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/divisi-arsa" className="box-link">
                                {/* <a className="box-link" href="/divisi-arsa"> */}
                                <img className="foto" src={arsa} alt="" />
                                <div className="shadow-top"></div>
                                <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(253,127,155,0), rgba(253,127,155,1)" }}></div>
                                <div className="info-divisi">
                                    <div className="box">
                                        <div className="box-text">
                                            <p className="divisi">Divisi</p>
                                            <p className="nama">ARSA</p>
                                        </div>
                                        <div className="box-logo">
                                            <img className="logo" src={arsaLogo} alt="" />
                                        </div>
                                    </div>
                                    <p className="job" style={{ fontStyle: "italic" }}>Person In Charge (PIC)</p>
                                </div>
                                {/* </a> */}
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/divisi-adhyasta" className="box-link">
                                {/* <a className="box-link" href="/divisi-adhyasta"> */}
                                <img className="foto" src={adhyasta} alt="" />
                                <div className="shadow-top"></div>
                                <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(0,0,0,0), rgba(0,0,0,1)" }}></div>
                                <div className="info-divisi">
                                    <div className="box">
                                        <div className="box-text">
                                            <p className="divisi">Divisi</p>
                                            <p className="nama">ADHYASTA</p>
                                        </div>
                                        <div className="box-logo">
                                            <img className="logo" src={adhyastaLogo} alt="" />
                                        </div>
                                    </div>
                                    <p className="job">Keamanan</p>
                                </div>
                                {/* </a> */}
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/divisi-syandana" className="box-link">
                                <a className="box-link" href="/divisi-syandana">
                                    <img className="foto" src={syandana} alt="" />
                                    <div className="shadow-top"></div>
                                    <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(77,77,77,0), rgba(77,77,77,1)" }}></div>
                                    <div className="info-divisi">
                                        <div className="box">
                                            <div className="box-text">
                                                <p className="divisi">Divisi</p>
                                                <p className="nama">SYANDANA</p>
                                            </div>
                                            <div className="box-logo">
                                                <img className="logo" src={syandanaLogo} alt="" />
                                            </div>
                                        </div>
                                        <p className="job" style={{ fontStyle: "italic" }}>Public Relation & Design</p>
                                    </div>
                                </a>
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/divisi-sambara" className="box-link">
                                {/* <a className="box-link" href="/divisi-sambara"> */}
                                <img className="foto" src={sambara} alt="" />
                                <div className="shadow-top"></div>
                                <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(147,0,210,0), rgba(147,0,210,1)" }}></div>
                                <div className="info-divisi">
                                    <div className="box">
                                        <div className="box-text">
                                            <p className="divisi">Divisi</p>
                                            <p className="nama">SAMBARA</p>
                                        </div>
                                        <div className="box-logo">
                                            <img className="logo" src={sambaraLogo} alt="" />
                                        </div>
                                    </div>
                                    <p className="job">Perlengkapan</p>
                                </div>
                                {/* </a> */}
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/divisi-dayaka" className="box-link">
                                {/* <a className="box-link" href="/divisi-dayaka"> */}
                                <img className="foto" src={dayaka} alt="" />
                                <div className="shadow-top"></div>
                                <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(203,167,139,0), rgba(203,167,139, 1)" }}></div>
                                <div className="info-divisi">
                                    <div className="box">
                                        <div className="box-text">
                                            <p className="divisi">Divisi</p>
                                            <p className="nama">DAYAKA</p>
                                        </div>
                                        <div className="box-logo">
                                            <img className="logo" src={dayakaLogo} alt="" />
                                        </div>
                                    </div>
                                    <p className="job">Konsumsi</p>
                                </div>
                                {/* </a> */}
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/divisi-sarwaga" className="box-link">
                                {/* <a className="box-link" href="/divisi-sarwaga"> */}
                                <img className="foto" src={sarwaga} alt="" />
                                <div className="shadow-top"></div>
                                <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(65,167,106,0), rgba(65,167,106, 1)" }}></div>
                                <div className="info-divisi">
                                    <div className="box">
                                        <div className="box-text">
                                            <p className="divisi">Divisi</p>
                                            <p className="nama">SARWAGA</p>
                                        </div>
                                        <div className="box-logo">
                                            <img className="logo" src={sarwagaLogo} alt="" />
                                        </div>
                                    </div>
                                    <p className="job">Medis</p>
                                </div>
                                {/* </a> */}
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/divisi-prabangkara" className="box-link">
                                {/* <a className="box-link" href="/divisi-prabangkara"> */}
                                <img className="foto" src={prabangkara} alt="" />
                                <div className="shadow-top"></div>
                                <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(255,96,0,0), rgba(255,96,0,1)" }}></div>
                                <div className="info-divisi">
                                    <div className="box">
                                        <div className="box-text">
                                            <p className="divisi">Divisi</p>
                                            <p className="nama">PRABANGKARA</p>
                                        </div>
                                        <div className="box-logo">
                                            <img className="logo" src={prabangkaraLogo} alt="" />
                                        </div>
                                    </div>
                                    <p className="job">Dokumentasi</p>
                                </div>
                                {/* </a> */}
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/divisi-wiskira" className="box-link">
                                {/* <a className="box-link" href="/divisi-wiskira"> */}
                                <img className="foto" src={wiskira} alt="" />
                                <div className="shadow-top"></div>
                                <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(225,173,1,0), rgba(225,173,1,1)" }}></div>
                                <div className="info-divisi">
                                    <div className="box">
                                        <div className="box-text">
                                            <p className="divisi">Divisi</p>
                                            <p className="nama">WISKIRA</p>
                                        </div>
                                        <div className="box-logo">
                                            <img className="logo" src={wiskiraLogo} alt="" />
                                        </div>
                                    </div>
                                    <p className="job" style={{ fontStyle: "italic" }}>Website</p>
                                </div>
                                {/* </a> */}
                            </Link>
                        </SwiperSlide>
                    </Swiper>
                    <div className="swiper-pagination" slot="pagination"></div>
                </div>
                <div className="box-grid">
                    <a className="box-link" href="/divisi-bimantara">
                        <img className="foto" src={bimantara} alt="" />
                        <div className="shadow-top"></div>
                        <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(16,82,184,0), rgba(16,82,184,1)" }}></div>
                        <div className="info-divisi">
                            <div className="box">
                                <div className="box-text">
                                    <p className="divisi">Divisi</p>
                                    <p className="nama">BIMANTARA</p>
                                </div>
                                <div className="box-logo">
                                    <img className="logo" src={bimantaraLogo} alt="" />
                                </div>
                            </div>
                            <p className="job">Badan Pengurus Harian (BPH)</p>
                        </div>
                    </a>
                    <a className="box-link" href="/divisi-kampana">
                        <img className="foto" src={kampana} alt="" />
                        <div className="shadow-top"></div>
                        <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(184,17,13,0), rgba(184,17,13,1)" }}></div>
                        <div className="info-divisi">
                            <div className="box">
                                <div className="box-text">
                                    <p className="divisi">Divisi</p>
                                    <p className="nama">KAMPANA</p>
                                </div>
                                <div className="box-logo">
                                    <img className="logo" src={kampanaLogo} alt="" />
                                </div>
                            </div>
                            <p className="job">Acara</p>
                        </div>
                    </a>
                    <a className="box-link" href="/divisi-arsa">
                        <img className="foto" src={arsa} alt="" />
                        <div className="shadow-top"></div>
                        <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(253,127,155,0), rgba(253,127,155,1)" }}></div>
                        <div className="info-divisi">
                            <div className="box">
                                <div className="box-text">
                                    <p className="divisi">Divisi</p>
                                    <p className="nama">ARSA</p>
                                </div>
                                <div className="box-logo">
                                    <img className="logo" src={arsaLogo} alt="" />
                                </div>
                            </div>
                            <p className="job" style={{ fontStyle: "italic" }}>Person In Charge (PIC)</p>
                        </div>
                    </a>
                    <a className="box-link" href="/divisi-adhyasta">
                        <img className="foto" src="adhyasta" alt="" />
                        <div className="shadow-top"></div>
                        <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(0,0,0,0), rgba(0,0,0,1)" }}></div>
                        <div className="info-divisi">
                            <div className="box">
                                <div className="box-text">
                                    <p className="divisi">Divisi</p>
                                    <p className="nama">ADHYASTA</p>
                                </div>
                                <div className="box-logo">
                                    <img className="logo" src={adhyastaLogo} alt="" />
                                </div>
                            </div>
                            <p className="job">Keamanan</p>
                        </div>
                    </a>
                    <a className="box-link" href="/divisi-syandana">
                        <img className="foto" src="syandana" alt="" />
                        <div className="shadow-top"></div>
                        <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(77,77,77,0), rgba(77,77,77,1)" }}></div>
                        <div className="info-divisi">
                            <div className="box">
                                <div className="box-text">
                                    <p className="divisi">Divisi</p>
                                    <p className="nama">SYANDANA</p>
                                </div>
                                <div className="box-logo">
                                    <img className="logo" src={syandanaLogo} alt="" />
                                </div>
                            </div>
                            <p className="job" style={{ fontStyle: "italic" }}>Public Relation & Design</p>
                        </div>
                    </a>
                    <a className="box-link" href="/divisi-sambara">
                        <img className="foto" src={sambara} alt="" />
                        <div className="shadow-top"></div>
                        <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(147,0,210,0), rgba(147,0,210,1)" }}></div>
                        <div className="info-divisi">
                            <div className="box">
                                <div className="box-text">
                                    <p className="divisi">Divisi</p>
                                    <p className="nama">SAMBARA</p>
                                </div>
                                <div className="box-logo">
                                    <img className="logo" src={sambaraLogo} alt="" />
                                </div>
                            </div>
                            <p className="job">Perlengkapan</p>
                        </div>
                    </a>
                    <a className="box-link" href="/divisi-dayaka">
                        <img className="foto" src={dayaka} alt="" />
                        <div className="shadow-top"></div>
                        <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(203,167,139,0), rgba(203,167,139, 1)" }}></div>
                        <div className="info-divisi">
                            <div className="box">
                                <div className="box-text">
                                    <p className="divisi">Divisi</p>
                                    <p className="nama">DAYAKA</p>
                                </div>
                                <div className="box-logo">
                                    <img className="logo" src={dayakaLogo} alt="" />
                                </div>
                            </div>
                            <p className="job">Konsumsi</p>
                        </div>
                    </a>
                    <a className="box-link" href="/divisi-sarwaga">
                        <img className="foto" src={sarwaga} alt="" />
                        <div className="shadow-top"></div>
                        <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(65,167,106,0), rgba(65,167,106, 1)" }}></div>
                        <div className="info-divisi">
                            <div className="box">
                                <div className="box-text">
                                    <p className="divisi">Divisi</p>
                                    <p className="nama">SARWAGA</p>
                                </div>
                                <div className="box-logo">
                                    <img className="logo" src={sarwagaLogo} alt="" />
                                </div>
                            </div>
                            <p className="job">Medis</p>
                        </div>
                    </a>
                    <a className="box-link" href="/divisi-prabangkara">
                        <img className="foto" src={prabangkara} alt="" />
                        <div className="shadow-top"></div>
                        <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(255,96,0,0), rgba(255,96,0,1)" }}></div>
                        <div className="info-divisi">
                            <div className="box">
                                <div className="box-text">
                                    <p className="divisi">Divisi</p>
                                    <p className="nama">PRABANGKARA</p>
                                </div>
                                <div className="box-logo">
                                    <img className="logo" src={prabangkaraLogo} alt="" />
                                </div>
                            </div>
                            <p className="job">Dokumentasi</p>
                        </div>
                    </a>
                    <a className="box-link" href="/divisi-wiskira">
                        <img className="foto" src={wiskira} alt="" />
                        <div className="shadow-top"></div>
                        <div className="shadow-divisi" style={{ background: "linear-gradient(rgba(225,173,1,0), rgba(225,173,1,1)" }}></div>
                        <div className="info-divisi">
                            <div className="box">
                                <div className="box-text">
                                    <p className="divisi">Divisi</p>
                                    <p className="nama">WISKIRA</p>
                                </div>
                                <div className="box-logo">
                                    <img className="logo" src={wiskiraLogo} alt="" />
                                </div>
                            </div>
                            <p className="job" style={{ fontStyle: "italic" }}>Website</p>
                        </div>
                    </a>
                </div>
            </div >
        </>
    )
}

export { NavigasiDivisi };